import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { DialogBase } from 't4core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapService } from 'app-components';

@Component({
  selector: 'app-return-faraway',
  templateUrl: './return-faraway.html',
  styleUrls: ['./return-faraway.css'],
  standalone: false
})
export class ReturnFarAwayDialog extends DialogBase implements OnInit, AfterViewInit, OnDestroy {
  public returnConfirmation: boolean = false;
  @ViewChild('gmap', { static: false }) gmapElement: any;

  private map: google.maps.Map;
  private zoomDistances = [
    { zoom: 17, maxDistance: 0.2 },
    { zoom: 15, maxDistance: 0.6 },
    { zoom: 14, maxDistance: 2 },
    { zoom: 12, maxDistance: 4 },
    { zoom: 11, maxDistance: 8 },
    { zoom: 9, maxDistance: 16 },
    { zoom: 8, maxDistance: 32 },
    { zoom: 7, maxDistance: 64 },
    { zoom: 6, maxDistance: 128 },
    { zoom: 5, maxDistance: 256 },
    { zoom: 4, maxDistance: 512 },
    { zoom: 3, maxDistance: 1024 },
    { zoom: 2, maxDistance: 2048 },
    { zoom: 1, maxDistance: 4096 }
  ];
  constructor(
    public dialogRef: MatDialogRef<ReturnFarAwayDialog>,
    @Inject(MAT_DIALOG_DATA) public data,
    private mapService: MapService) {
    super("ReturnFarAwayDialog");

  }
  async ngOnInit() {
    this.returnConfirmation = false;
  }
  ngOnDestroy() {
    // Detach the map div to preserve it for reuse
    this.mapService.detachMapInstance('return-faraway');
    this.map = null;
  }
  public understand() {
    this.dialogRef.close('ok');
  }
  public atLocation() {
    this.returnConfirmation = true;
  }
  public confirmReturn() {
    this.dialogRef.close('return');
  }
  async ngAfterViewInit() {
    await this.initMap();
  }

  public async initMap() {
    if (this.map) return;

    var mapProp = {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      key: "AIzaSyBEjGnurCxh3ZDYNjyxQDlaCZXQxxvM0-E",
      disableDefaultUI: true,
      mapId: '17c55b6aa3c322c5',
      zoom: this.zoomDistances.find(x => x.maxDistance > this.data.distance).zoom,
      center: { lat: this.data.trailerPointLatitude, lng: this.data.trailerPointLongitude },

    };

    if (this.gmapElement && this.gmapElement.nativeElement) {
      this.map = this.mapService.getMapInstance('return-faraway', this.gmapElement.nativeElement, mapProp);
    }
    this.placeTrailerPoint(true);
  }



  private pin: google.maps.Marker;
  private marker: google.maps.Marker;
  private circle: google.maps.Circle;
  private async placeTrailerPoint(firstLoad: boolean = false) {
    if (!this.map) return;

    if (this.pin) {
      this.pin.setMap(null);
    }

    if (!this.data.cordinates) return;

    this.pin = new google.maps.Marker({
      position: { lat: this.data.cordinates.Latitude, lng: this.data.cordinates.Longitude },
      draggable: false,
      map: this.map,
    });

    if (!this.marker) {
      this.marker = new google.maps.Marker({
        position: { lat: this.data.trailerPointLatitude, lng: this.data.trailerPointLongitude },
        draggable: false,
        map: this.map,
      });
      const theme = this.data.theme || 'Default';
      this.marker.setIcon(`/Styles/${theme}/Pin.png`);

      var circle = new google.maps.Circle({
        strokeColor: "#ADD8E6",
        strokeOpacity: 0.8,
        fillColor: "#32CD32",
        strokeWeight: 1,
        map: this.map,
        fillOpacity: 0.35,
        radius: this.data.trailerPointRadius
      })


      this.circle = circle;
      this.circle.bindTo('center', this.marker, 'position');
    }

    if (firstLoad) {
      this.map.setZoom(this.zoomDistances.find(x => x.maxDistance > this.data.distance).zoom);

      setTimeout(() => this.map.panTo({ lat: (this.data.trailerPointLatitude + this.data.cordinates.Latitude) / 2, lng: (this.data.trailerPointLongitude + this.data.cordinates.Longitude) / 2 }), 100);
    }
  }
}
